// Per-stage visibility toggle row for the CPLEX Sankey HUD.
//
// Renders one button per Sankey stage. Clicking flips visibility for that
// stage; the parent rebuilds the sankey payload with only the visible
// stages and the chart reflows. Hidden stages drop their nodes; remaining
// stages reconnect through the gap (handled in buildSankeyFromMPP).
//
// At least one stage must stay visible — the row enforces this by ignoring
// a click that would turn off the last enabled stage.

import { STAGES, STAGE_COLORS, STAGE_LABELS, type Stage } from './mppHelpers';
import styles from './StageToggle.module.css';

interface StageToggleProps {
  visible: ReadonlySet<Stage>;
  onToggle: (stage: Stage) => void;
}

export function StageToggle({ visible, onToggle }: StageToggleProps) {
  return (
    <div className={styles.row} role="group" aria-label="Toggle Sankey columns">
      <span className={styles.label}>Columns</span>
      {STAGES.map((s) => {
        const on = visible.has(s);
        const color = STAGE_COLORS[s] ?? '#64748b';
        return (
          <button
            type="button"
            key={s}
            className={`${styles.btn} ${on ? styles.btnOn : ''}`}
            style={{ ['--stage-color' as string]: color }}
            aria-pressed={on}
            onClick={() => onToggle(s)}
          >
            <span className={styles.dot} aria-hidden="true" />
            {STAGE_LABELS[s]}
          </button>
        );
      })}
    </div>
  );
}
